import styled from "@emotion/styled";
import { TextField } from "@mui/material";

const StyledTextField = styled(TextField)({
  label: {
    color: "#6f7780",
  },
  input: {
    color: "#fff",
  },
  "& label.Mui-focused": {
    color: "#fff",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#fff",
  },
  "& .MuiOutlinedInput-root": {
    "border-radius": "0px",
    background: "#1A1A2C",
    "& fieldset": {
      borderColor: "#1A1A2C",
    },
    "&:hover fieldset": {
      borderColor: "#1A1A2C",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
    },
  },
});

export default StyledTextField;
